import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import CustomFooter from '../components/Footer';
import { fetchConversations } from '../api/messages';
import { FaUserCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Messages = () => {
    const [messages, setMessages] = useState([]);

    useEffect(() => {
        const getMessages = async () => {
            try {
                const response = await fetchConversations();
                setMessages(response.data);
            } catch (error) {
                console.error("Error fetching messages:", error);
            }
        };
        getMessages();
    }, []);

    return (
        <div className="bg-gray-100 min-h-screen flex flex-col">
            <Header />
            <div className="flex-grow container mx-auto p-6">
                <div className="bg-white rounded-lg shadow-md p-6">
                    <h2 className="text-2xl font-semibold mb-4">Messages</h2>
                    {messages.length === 0 ? (
                        <p className="text-gray-600">No messages received.</p>
                    ) : (
                        <ul>
                            {messages.map((message, index) => (
                                <li key={index} className="mb-4">
                                    <Link to={`/messages/${message.username}`}
                                    className="block border border-gray-300 p-3 rounded hover:bg-gray-700 transition bg-white-500 text-black py-2 px-4 rounded text-center">
                                        <div className="flex items-center mb-2">
                                        <FaUserCircle className="text-2xl mr-2" />
                                            <span className="font-semibold">{message.sender}</span>
                                        </div>
                                        {(message.status !== "new")||(<div className="block border transition bg-red-500  py-2 px-4 rounded"></div>)}                                     
                                    </Link>  
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
            <CustomFooter />
        </div>
    );
};

export default Messages;